import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

// utils
import store from "@/store";
// Routes
import AuthRouter from "./auth/";
import BackofficeLocalManagerRouter from "./backoffice/RouterLocalManager";
import BackofficeRegionalManagerRouter from "./backoffice/RouterRegionalManager";
import BackofficeAdministratorRouter from "./backoffice/RouterAdministrator";
import BackofficeCollaboratorRouter from "./backoffice/RouterCollaborator";

const routes = [
  {
    path: "/",
    name: "Home",
    beforeEnter: (to, from, next) => {
      const { auth, level, operator } = localStorage;
      if (auth === "true") {
        next({ name: level });
      } else {
        next({ path: `/auth/login/${operator}` });
      }
    },
  },
  AuthRouter,
  BackofficeLocalManagerRouter,
  BackofficeRegionalManagerRouter,
  BackofficeAdministratorRouter,
  BackofficeCollaboratorRouter,
  { path: "*", redirect: "/404" },
  { path: "/404", component: () => import("../views/404") },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // Main Container Fluid (template.vue)
  // Para quando a view precisa ser fluída
  // ou ter mais espaço;
  if (to.matched.some((record) => record.meta.fluid)) {
    store.commit("mainContainerFluid", true);
  } else {
    store.commit("mainContainerFluid", false);
  }

  // Request:
  if (to.matched.some((record) => record.meta.request)) {
    store.commit("setFeedbackProgress", true);
  }

  // Authenticate Routes:
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.auth === "true") {
      next();
    } else {
      next({
        path: `/auth/login/${localStorage.operator}`,
        // query: { redirect: to.fullPath }
      });
    }
  }

  next();
});

export default router;
